<template>
    <div :key="$route.path">
        <ul class="list-group MobileHide">
        <li class="list-group-item header LeagueName MobileHide">{{lName}}</li>
        <li class="list-group-item" style="color: white; background: #39b54a;">
            <div class="row">
            <div class="col">
                #
            </div>
            <div class="col-6">
                {{ $t('LanguageEn.txtTeam') }}
            </div>
            <div class="col">
                {{ $t('LanguageEn.txtTableCount') }}
            </div>
            <div class="col">
                {{ $t('LanguageEn.txtTableWin') }}
            </div>
            <div class="col">
                {{ $t('LanguageEn.txtTableDraw') }}
            </div>
            <div class="col">
                {{ $t('LanguageEn.txtTableLose') }}
            </div>
            <div class="col">
                {{ $t('LanguageEn.txtTableGoals') }}
            </div>
            <div class="col">
                {{ $t('LanguageEn.txtTablePoint') }}
            </div>
        </div>
        </li>
        <div v-for="table in standings" :key="table.idll" >
          <div v-for="(group, i) in table" :key="group.id" >
        <li class="list-group-item header " style="background: #4d4d4d; margin-top: 0px; margin-bottom: 0px; color: white; text-align: center; line-height: 5px;" v-if="i < 1 && group.groupName">{{group.groupName}}</li>
        <li style="height: 35px; border: none; font-size: 14px" class="list-group-item" v-bind:class="{blackBg: group.position % 2 == 0}">
            <router-link style="text-decoration: none;" id="router-link" :to="{ name: 'teamPagePar', params: { id: group.team.id} }"><div class="row">
                <div class="col" style="color: #333333;">
                    {{group.position}}
                </div>
                <div class="col-6" style="color: #333333;">
                    {{group.team.name}}
                </div>
                <div class="col" style="color: #333333;">
                    {{group.gameCount}}
                </div>
                <div class="col" style="color: #333333;">
                    {{group.win}}
                </div>
                <div class="col" style="color: #333333;">
                    {{group.draw}}
                </div>
                <div class="col" style="color: #333333;">
                    {{group.lose}}
                </div>
                <div class="col" style="color: #333333; text-align: center;">
                    {{group.goalScored - group.goalAgainst}}
                </div>
                <div class="col" style="color: #333333;">
                    {{group.points}}
                </div>
            </div></router-link>
        </li>
        </div>
        </div>
        </ul>
        <ul class="list-group MobileShow">
        <li class="list-group-item header LeagueName MobileHide">{{lName}}</li>
        <li class="list-group-item" style="color: white; background: #39b54a;">
            <div class="row">
            <div class="col pr-1">
                #
            </div>
             <div class="col">
                F
            </div>
            <div class="col-2 pl-1">
                {{ $t('LanguageEn.txtTeam') }}
            </div>
            <div class="col">
                {{ $t('LanguageEn.txtTableCount') }}
            </div>
            <div class="col">
                {{ $t('LanguageEn.txtTableWin') }}
            </div>
            <div class="col">
                {{ $t('LanguageEn.txtTableDraw') }}
            </div>
            <div class="col">
                {{ $t('LanguageEn.txtTableLose') }}
            </div>
            <div class="col">
                {{ $t('LanguageEn.txtTableGoals') }}
            </div>
            <div class="col">
                {{ $t('LanguageEn.txtTablePoint') }}
            </div>
        </div>
        </li>
       <div v-for="table in standings" :key="table.idll" >
          <div v-for="(group, i) in table" :key="group.id" >
        <li class="list-group-item header " style="background: #4d4d4d; margin-top: 0px; margin-bottom: 0px; color: white; text-align: center; line-height: 5px;" v-if="i < 1 && group.groupName">{{group.groupName}}</li>
        <li style="height: 35px; border: none; font-size: 14px" class="list-group-item" v-bind:class="{blackBg: group.position % 2 == 0}">
            <router-link style="text-decoration: none;" id="router-link" :to="{ name: 'teamPagePar', params: { id: group.team.id } }"><div class="row">
                <div class="col pr-1" style="color: #333333;">
                    {{group.position}}
                </div>
                <div class="col" style="color: #333333;">
                     <img :src="teamLogo + group.team.id" alt="" style="width: 17px; margin-top: -3px;" >
                </div>
                <div class="col-2 pl-1" style="color: #333333; font-size: 13px; margin-top: 2px;" v-if="group.team.shortCode">
                    {{group.team.shortCode}}
                </div>
                <div class="col-2 pl-1" style="color: #333333; font-size: 13px;" v-else>
                    {{group.team.name.slice(0,3)}}
                </div>
                <div class="col" style="color: #333333;">
                    {{group.gameCount}}
                </div>
                <div class="col" style="color: #333333;">
                    {{group.win}}
                </div>
                <div class="col" style="color: #333333;">
                    {{group.draw}}
                </div>
                <div class="col" style="color: #333333;">
                    {{group.lose}}
                </div>
                <div class="col" style="color: #333333;">
                    {{group.goalScored - group.goalAgainst}}
                </div>
                <div class="col" style="color: #333333;">
                    {{group.points}}
                </div>
            </div></router-link>
        </li>
        </div>
        </div>
        </ul>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {

    
  name: 'LeaguePage',
  data(){
      return{
          leagueTable: [],
          id : '',
          cookiesObject: '',
          teamLogo: 'https://sportapi.zuniac.com/team/logo/',
          standings: [],
          lName: '',
      }
  },
  async created(){
    this.id = this.$route.params.leagueId;

    var cookiesObject = document.cookie.split(';').map(cookie => cookie.split('=')).reduce((accumulator, [key, value]) => ({...accumulator, [key.trim()]: decodeURIComponent(value)}),{});
    this.cookiesObject = cookiesObject;


     const res = await fetch(this.httpReq + '/standings?portalId='+ cookiesObject.portalId +'&token='+ cookiesObject.token +'&tournamentId=' + this.id);
     const data = await res.json();
     const leagueTable = data;
     this.leagueTable = leagueTable;
     this.lName = leagueTable.standings[0].tournament.name;

     this.standings = this.groupBy(this.leagueTable.standings, 'groupName');

  },
  components: {
  },
  props: {
  },
  methods: {
      groupBy(objectArray, property) {
      return objectArray.reduce((acc, obj) => {
          const key = obj[property];
          if (!acc[key]) {
            acc[key] = [];
          }
          // Add object to list for given key's value
          acc[key].push(obj);
          return acc;
      }, {});
}
  },
  computed:{
       ...mapGetters(['httpReq']),
  },
}
</script>

<style scoped>

.list-group-item{
    line-height: 6px;
    border-radius: 0px;
    border: none;
    font-size: 13px;
}
.blackBg{
  background: #e6e6e6;
}
.LeagueName{
    margin-bottom: 10px;
    margin-top: 10px;
    text-align: center;
    font-size: 14px;
}

.header{
    background: #242424;
    color: white;
}
 #router-link, #router-link:visited, #router-link:active, #router-link:focus{
    text-decoration: none;
    border: 0;
    outline: 0;
    color: #242424;
  }

  @media only screen and (max-width: 770px) {
  body{
    background: #212529;
  }
  .navDiv2{
    width: 100%;
    height: 60px;
    color: white;
    background: #1b1d20;  
}
  .MobileHide {
    display: none;
  }
}

@media only screen and (min-width: 770px) {
  .MobileShow {
    display: none;
  }

}

</style>
